<script lang="ts">
	import { SidepanelContent, Text } from '@Shelly/shelly-design-system';
	import DeviceChartsDrawer from 'src/components/Chart/DeviceChartsDrawer.svelte';
	import { getDeviceChartsConfig } from 'src/components/Chart/chart_config';
	import { isFanDevice } from 'src/helpers/interface_helpers';
	import type { Device } from 'src/types/Device.ts';
	import type { ChartConfigInterface } from 'src/types/Chart';
	import { format } from 'svelte-i18n';

	export let device: Device;

	let deviceChartsConfig: ChartConfigInterface[] = [];
	$: deviceChartsConfig = device ? getDeviceChartsConfig(device) : [];
	$: showVentoraEnvChartsHelp =
		device &&
		isFanDevice(device.type) &&
		deviceChartsConfig.some((c) => c.url === 'statistics/sensor/values');
</script>

<SidepanelContent>
	{#if showVentoraEnvChartsHelp}
		<Text class="mb-s" styleType="body-small">
			{$format('ventora_statistics_env_charts_help', {
				default:
					'This fan can show internal temperature and humidity history here when the cloud provides data. For charts on other hardware, use a Shelly H&T sensor or a relay with a supported temperature/humidity add-on.',
			})}
		</Text>
	{/if}
	<DeviceChartsDrawer {device} {deviceChartsConfig} />
</SidepanelContent>
